/**
 * 关于我们页面静态数据
 */

// 公司简介数据
export const aboutIntroData = {
  title: '公司简介',
  para_1: '福建平潭瑞谦智能科技有限公司是一家专业从事人工智能软件开发的国家高新技术企业，机器视觉解决方案提供者和创新者，致力于为学校、企业、政务客户提供集软件开发、系统集成、IT运维等一体的信息化综合解决方案。公司的主营业务涉及规模化完整AI+3D+机器视觉复杂解决方案、物联网、智慧终端解决方案、智能终端。通过物联网设备进行全面感知并有效获取海量数据，结合传感网、大数据、人工智能和云计算进行数据的分析和提炼，可大幅提升工作效率和效果，实现生活的信息化和现代化，推动机器视觉技术在工业制造中迈向智慧化的新纪元。',
  para_2: '瑞谦智能秉承"科技创新驱动未来"的经营理念，致力于推动人工智能技术普及，让人工智能物联网贯穿我们智能生态全产品、全平台、全场景。公司拥有强大的技术研发能力和多层次科技人才以及完善的管理治理能力。自成立以来，先后通过国家高新技术企业、科技型中小企业，获"全国电子信息行业优秀企业"、"电子信息行业价值企业"、福建省科技小巨人企业、福建省"瞪羚"企业、"中国创新创业大赛（福建赛区）优秀企业"等多项荣誉称号。',
  imgArr: [
    {
      id: '1',
      imgUrl: '/img/about/intro_1.jpg',
      alt: '正面夜景'
    },
    {
      id: '2',
      imgUrl: '/img/about/intro_2.jpg',
      alt: '正面白天'
    },
    {
      id: '3',
      imgUrl: '/img/about/intro_3.jpg',
      alt: '斜对角夜景'
    },
    {
      id: '4',
      imgUrl: '/img/about/intro_4.jpg',
      alt: '展厅'
    },
    {
      id: '5',
      imgUrl: '/img/about/intro_5.jpg',
      alt: '办公区'
    },
    {
      id: '6',
      imgUrl: '/img/about/intro_6.jpg',
      alt: '公司路口'
    }
  ]
}

// 企业文化数据
export const aboutCultureData = {
  title: '企业文化',
  bg: {
    bgUrl: '/img/about/culture_bg.jpg',
    alt: '前台logo'
  },
  content: [
    {
      id: '1',
      title: '企业使命',
      text: '为生活带来便捷与安全'
    },
    {
      id: '2',
      title: '经营理念',
      text: '科技创新驱动未来'
    },
    {
      id: '3',
      title: '企业愿景',
      text: '成为智能解决方案的创造者和领导者'
    },
    {
      id: '4',
      title: '企业精神',
      text: '"三个一"精神；诚信第一，服务第一，品质第一'
    },
    {
      id: '5',
      title: '企业价值观',
      text: '负责、诚信、尊重、创新、专业'
    }
  ]
}

// 企业荣誉数据
export const aboutHonorData = {
  title: '企业荣誉',
  paraArr: [
    {
      id: '1',
      text: '公司已获得发明专利、软件著作权等知识产权80余件，并通过ISO14001、ISO9001、ISO27001、ISO45001等体系认证。'
    },
    {
      id: '2',
      text: '公司自成立以来，先后通过国家高新技术企业、科技型中小企业、实验区重点产业企业认定，获"全国电子信息行业优秀企业"、"电子信息行业价值企业"、福建省科技小巨人企业、福建省"瞪羚"企业、"中国创新创业大赛（福建赛区）优秀企业"等多项荣誉称号。'
    },
    {
      id: '3',
      text: '公司创新产品与技术连续多年入编《电子信息行业自主创新成果推广目录》，获得中国电子信息行业联合会颁发的自主创新技术奖，自主研发的"人脸识别模块"、"人脸核验系统"入选 2021"国货新品"。'
    }
  ],
  imgArr: [
    {
      id: '1',
      imgUrl: '/img/about/honor_1.jpg',
      alt: '高新技术企业证书'
    },
    {
      id: '2',
      imgUrl: '/img/about/honor_2.jpg',
      alt: '2022年福建省数字经济领域"瞪羚"创新企业'
    },
    /* {
      id: '3',
      imgUrl: '/img/about/honor_3.jpg',
      alt: '科技型中小型企业认定证书'
    }, */
    {
      id: '4',
      imgUrl: '/img/about/honor_4.jpg',
      alt: '荣誉证书'
    },
    {
      id: '5',
      imgUrl: '/img/about/honor_5.jpg',
      alt: '荣誉证书'
    },
    /* {
      id: '6',
      imgUrl: '/img/about/honor_6.jpg',
      alt: '荣誉证书'
    }, */
    /* {
      id: '7',
      imgUrl: '/img/about/honor_7.jpg',
      alt: '重点产业企业'
    }, */
    {
      id: '8',
      imgUrl: '/img/about/honor_8.jpg',
      alt: '2022年平潭青年五四奖章集体'
    },
    {
      id: '9',
      imgUrl: '/img/about/honor_9.jpg',
      alt: '人工智能科普教育基地'
    }
  ]
}

